import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { RestoreSessionService } from '../services/restore-session.service';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(RestoreSessionService);
  const token = session.token();
  const applicationId = session.applicationId();

  let headers = req.headers.set('Accept-Language', 'uk-UA');
  if (token) headers = headers.set('Authorization', `Bearer ${token}`);
  if (applicationId) headers = headers.set('X-Application-Id', applicationId);
  // fcm (Firebase Cloud Messaging token) is stored in session but forwarding to API is deferred

  return next(req.clone({ headers }));
};
